import {
  PLAY_COUPON_REQUEST,
  PLAY_COUPON_SUCCESS,
  PLAY_COUPON_FAILURE,
  PLAY_COUPON_UPDATE_PREDICTA,
  RESET_PLAY_COUPON
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null,
  calculatedProbability: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAY_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };

    case PLAY_COUPON_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };

    case PLAY_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case PLAY_COUPON_UPDATE_PREDICTA:
      return {
        ...state,
        calculatedProbability: action.payload ?? 0
      };

    case RESET_PLAY_COUPON:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
